export default {
  name: 'MdmLink',
  props: {
    url: {
      type: String,
      required: true
    },
    isNuxt: {
      type: Boolean,
      default: false
    },
    isScrambleLink: {
      type: Boolean,
      default: false
    },
    isPreventDefaultLink: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      enableLink: false
    };
  },
  computed: {
    component() {
      var noScrambleStateforClient = this.isScrambleLink && this.enableLink;
      var noScramble = !this.isScrambleLink || noScrambleStateforClient;
      var isTagA = !this.isNuxt && noScramble && this.hasUrl;
      var isTagNuxt = this.isNuxt && noScramble && this.hasUrl;
      if (isTagNuxt) return 'nuxt-link';
      if (isTagA) return 'a';
      return 'span';
    },
    hasUrl() {
      return !!this.url.length;
    },
    link() {
      switch (this.component) {
        case 'nuxt-link':
          return {
            to: this.url
          };
        case 'a':
          return {
            href: this.url
          };
        default:
          return null;
      }
    }
  },
  mounted() {
    this.enableLink = Boolean(window.__mdm_is_not_bot__);
  },
  methods: {
    handleClick(e) {
      if (this.isPreventDefaultLink) {
        e.preventDefault();
      }
      this.$emit('click');
    }
  }
};